import React from "react";

import { Container } from "./style";

export default function SideText({ color, zIndex = 0, ...props }) {
  return (
    <Container color={color} zIndex={zIndex}>
      <div className="find-more" style={{ animationDuration: "2.5s" }}>
        <span className="minor" />
        <span className="bigger" />
      </div>
      <p className="find-more" style={{ animationDuration: "2.5s" }}>
        Toque e descubra
      </p>
    </Container>
  );
}
